import Vuex from 'vuex'
import Vue from 'vue'
import api from '@/api/index'
import { formatRes } from '@/i18n/tool'
import {defaultI18n } from '@/i18n/local'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    i18n: new Map(),
    langList: [],
    currentLangs: {}
  },
  mutations: {
    setI18n(state, {code, lang}) {
      state.i18n.set(code, lang )
    },
    setLanglist(state, list) {
      console.log('set langs', list)
      state.langList = list
    },
    setCurrentLangs(state, lang) {
      state.currentLangs = lang
    }
  },
  actions: {
    async getLanguages({commit}) {
      const { result, data } = await api.home.getLanguages()
      if (result && data) {
        console.log('getLanguages', data.data)
        commit('setLanglist', data.data || [])
      }
    },
    async getI18n({commit}, lang) {
      const { result, data } = await api.home.getI18nConfig(lang.code)
      if (result && data) {
        if(data.data.Page_index_forget_text) {

            commit('setI18n',{
              code: lang.code,
              lang: formatRes(data.data)
            })
            commit('setCurrentLangs', lang)
            setFavicon(data.data.Page_favicon)
            setTitle(data.data.Page_title)
          }
        else {
          
        }
      }
    }, 
    async getDefaultLangs({dispatch}) {
      const isChina =  defaultI18n === 'cn'
      dispatch(
        'getI18n',
        {
          code: isChina? "zh_cn" : 'en_us',
          description: isChina ? "简体中文" : 'English'
        }
      )
    }
  }
})
function setFavicon (url) {
  let link = document.querySelector('link')
  link.setAttribute('href', url)
  link = null
}
function setTitle (title) {
  let titleEl = document.querySelector('title')
  titleEl.innerText = title
}
export default store